import type { IntroStage } from '@/lib/intro'

import { useSyncExternalStore } from 'react'
import { introStore } from '@/lib/intro'

export const useIntroStage = (): IntroStage => useSyncExternalStore(introStore.subscribe, introStore.getStage, introStore.getServerStage)
